import { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className={`back-to-top fixed bottom-8 right-8 z-40 w-11 h-11 rounded-full bg-sage text-white flex items-center justify-center shadow-lg shadow-sage/30 hover:bg-sage-dark cursor-pointer ${visible ? 'visible' : 'hidden'}`}
      aria-label="Voltar ao topo"
    >
      <ArrowUp size={18} strokeWidth={2} />
    </button>
  );
}
